export enum SigningDeviceTypes {
  MOBILE = 'SMALL_TOUCH',
  DESKTOP = 'REMOTE',
  LARGE_TOUCH = 'LARGE_TOUCH',
}

export enum SignatureStatus {
  STARTED = 'SIGNATURE_SIGNING_STARTED',
  COMPLETED = 'SIGNATURE_SIGNING_COMPLETED',
  FAILED = 'SIGNATURE_SIGNING_FAILED',
  CANCELLED = 'SIGNATURE_SIGNING_CANCELLED',
  FETCHED = 'SIGNATURE_FETCHING_COMPLETED',
  FETCH_FAILED = 'SIGNATURE_FETCHING_FAILED',
}

export enum CallbackStatus {
SYNC = 'SYNC',
ASYNC = 'ASYNC',
GENERATION_COMPLETED = 'GENERATION_CALLBACK_COMPLETED',
GENERATION_FAILED = 'GENERATION_CALLBACK_FAILED',
FETCH_COMPLETED = 'FETCHING_CALLBACK_COMPLETED',
FETCH = 'FETCHING_CALLBACK_FAILED',
SIGNING_COMPLETED = 'SIGNING_CALLBACK_COMPLETED',
SIGNING_FAILED = 'SIGNING_CALLBACK_FAILED',
}

export enum DocumentStatus {
  ACCEPTING = 'ACCEPTING',
  PROCESSING = 'PROCESSING',
}

export interface SignatureState {
  timestamp?: number;
  signatureStatus: SignatureStatus;
  callbackStatus?: CallbackStatus;
  signingUrl: string;
  callbackUrl?: string;
  execution?: {
    exceptionDescription?: string;
    exceptionMessage?: string;
  };
}
